import classNames from "classnames";
import DropDown from "components/DesignSystem/Dropdown/Dropdown";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { motion } from "framer-motion";
import ToolTip from "components/design/toolTip";
import { Cross } from "components/icons/Cross";

const Root = ({
  children,
  open,
  setOpen,
}: {
  children: React.ReactNode;
  open: boolean;
  setOpen: (val: boolean) => void;
}) => (
  <DropDown.Root open={open} onOpenChange={setOpen}>
    {children}
  </DropDown.Root>
);

const Trigger = ({
  isActive,
  onClear,
  icon,
  selectedCount,
  setOpen,
}: {
  isActive: boolean;
  onClear: () => void;
  icon: React.ReactNode;
  selectedCount: number;
  setOpen: (val: boolean) => void;
}) => (
  <div className="t-flex t-items-center t-gap-2">
    {isActive && (
      <ToolTip text="Clear section filter">
        <button
          className="all:unset t-cursor-pointer t-text-text-30 t-pt-1"
          onClick={onClear}
        >
          <Cross />
        </button>
      </ToolTip>
    )}
    <DropDown.Trigger
      className="t-text-text-30 group-data-state-open:t-text-purple"
      {...DropdownMenu.Trigger}
      asChild
      onClick={() => setOpen(true)}
    >
      <div className="t-relative">
        <button className="all:unset">{icon}</button>
        {isActive && (
          <span className="t-absolute t-w-4 t-h-4 t-bg-purple-0 t-rounded-full t-flex t-items-center t-justify-center t-text-purple-70 t-text-body-sm -t-right-1 -t-top-1">
            {selectedCount}
          </span>
        )}
      </div>
    </DropDown.Trigger>
  </div>
);

const Body = ({ children }: { children: React.ReactNode }) => (
  <motion.div className="t-flex-1 t-overflow-auto t-p-4">{children}</motion.div>
);

const Footer = ({ children }: { children: React.ReactNode }) => (
  <div className="t-border t-px-4 t-py-2 t-border-solid t-border-l-0 t-border-r-0 t-border-b-0 t-border-neutral-0 t-flex t-gap-2 t-justify-end t-min-h-max">
    {children}
  </div>
);

const Content = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <DropdownMenu.Content
    {...DropdownMenu.Content}
    asChild
    sideOffset={8}
    alignOffset={0}
    align="end"
    className="t-bg-white"
  >
    <motion.div
      className={classNames(
        "t-z-dropdown t-relative t-border-solid t-min-w-56 t-border t-border-neutral-10 t-shadow-light-100 t-rounded-md t-bg-surface t-text-body-sm t-flex t-flex-col",
        {
          [className]: className,
        }
      )}
      initial={{ y: -10 }}
      animate={{ y: 0 }}
      exit={{ y: -10 }}
    >
      {children}
    </motion.div>
  </DropdownMenu.Content>
);

const HeaderFilter = {
  Root,
  Trigger,
  Body,
  Footer,
  Content,
  Portal: DropdownMenu.Portal,
};

export default HeaderFilter;
